
import { useEffect, useState, useRef } from 'react';

export default function Subpoena() {
  const [animated, setAnimated] = useState(false);
  const [nothingScale, setNothingScale] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
          setTimeout(() => setNothingScale(true), 500);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const cannotProduce = [
    'No audio',
    'No transcripts',
    'No documents',
    'No content logs',
  ];

  const canConfirm = [
    'Account existence',
    'Generation timestamps',
  ];

  return (
    <section ref={sectionRef} className="relative py-24 bg-[#09090b]">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <h2 className="font-harvey-serif text-white text-3xl sm:text-[42px] font-normal tracking-tight text-center mb-16 sm:mb-20">
          If Subpoenaed
        </h2>

        <div className="max-w-[900px] mx-auto space-y-12 sm:space-y-16">
          <div
            className={`text-center transition-all duration-1000 ${
              nothingScale ? 'opacity-100 scale-100' : 'opacity-0 scale-50'
            }`}
          >
            <p className="font-harvey-serif text-[#06b6d4] text-5xl sm:text-7xl font-normal tracking-tight mb-6 sm:mb-8"
               style={{
                 textShadow: '0 0 60px rgba(6, 182, 212, 0.6), 0 0 120px rgba(6, 182, 212, 0.3)'
               }}>
              Nothing
            </p>
            <p className="font-harvey-sans text-white text-xl sm:text-2xl font-medium tracking-wide">
              We would produce nothing
            </p>
          </div>

          <div
            className={`p-6 sm:p-8 bg-[#0f0f11] border border-[#1a1a1c] rounded-xl transition-all duration-700 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            <div className="space-y-3 sm:space-y-4">
              {cannotProduce.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-red-500 text-lg sm:text-xl">✕</span>
                  <span className="font-harvey-sans text-[#d4d4d8] text-base sm:text-lg font-light tracking-wide">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div
            className={`p-6 sm:p-8 bg-[#0f0f11] border border-[#06b6d4]/30 rounded-xl transition-all duration-700 delay-200 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            <p className="font-harvey-sans text-white text-lg sm:text-xl font-medium tracking-wide mb-4 sm:mb-6">
              We can confirm:
            </p>
            <div className="space-y-3 sm:space-y-4">
              {canConfirm.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-[#06b6d4] text-lg sm:text-xl">✓</span>
                  <span className="font-harvey-sans text-[#d4d4d8] text-base sm:text-lg font-light tracking-wide">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <p
            className={`font-harvey-sans text-[#a1a1aa] text-lg sm:text-xl font-light tracking-wide text-center transition-all duration-700 delay-400 ${
              animated ? 'opacity-100' : 'opacity-0'
            }`}
          >
            We cannot produce content because we do not possess it
          </p>

          <p
            className={`font-harvey-serif text-[#06b6d4] text-xl sm:text-2xl font-normal tracking-tight text-center transition-all duration-700 delay-600 ${
              animated ? 'opacity-100' : 'opacity-0'
            }`}
          >
            This is not policy. This is architecture
          </p>
        </div>
      </div>
    </section>
  );
}
